<template>
  <div name="partner" class="partner">
    <div class="title">
      <li></li>
      企业优选
      <li></li>
    </div>
    <div class="index-goods-box">
      <div class="index-goods-title">
        <div class="index-goods-total">
          共 <span>{{total}}</span> 个商品，显示20款
        </div>
      </div>
      <div class="index_goods_list">
        <ul>
          <li v-for="(item, index) in msg" :key="index" :class="{'index_goods_list_none': !item.company_ids.includes(company_id) && company_id != 0}">
            <router-link :to="'/goodsDetail/' + item.sku" v-if="company_id === 0 || item.company_ids.includes(company_id)">
              <div>
                <div class="index_goods_img">
                  <img :src="item.img" />
                </div>
                <span>
                  <i class="more2_info_self">自营</i>{{ item.name | ellipsis }}
                </span>
                <p class="index-goods-price">目录价：¥ {{item.price}}</p>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
      <div class="index-goods-button">
        <router-link :to='"/goodsList"'>更多商品</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import store from "@/vuex/store";
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "Partner",
  data() {
    return {
      msg: [],
      total: 0,
      company_id: ''
    };
  },
  filters: {
    ellipsis(value) {
      if (!value) return "";
      if (value.length > 36) {
        return value.slice(0, 36) + "...";
      }
      return value;
    }
  },
  computed: {
    ...mapState(['userInfo']),
  },
  methods: {
    ...mapActions(["loadGoods"]),
    test() {
      this.loadGoods().then(data => {
        this.msg = data.result;
        this.total = data.total;
      });
    },
  },
  mounted() {
    this.test();
    if(this.userInfo.company_id === undefined){
      this.company_id = 0
    }else{
      this.company_id = this.userInfo.company_id
    }
  }
};
</script>
<style scoped>
.title {
  margin: 40px;
  font-size: 36px;
  font-weight: 700;
  text-align: center;
  color: #333;
}
.title li {
  display: inline-block;
  margin: 0 25px;
  width: 25px;
  height: 23px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAXCAYAAAD+4+QTAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAgY0hSTQAAeiYAAICEAAD6AAAAgOgAAHUwAADqYAAAOpgAABdwnLpRPAAAAAZiS0dEAP8A/wD/oL2nkwAAANBJREFUSMftVsENwyAM5N0skCnaT17tmgwBnYGwRoEt0gXau9SRKhQpgUp9tFg6ObbPUTCcgooxnkMII3AHPOIBUCklRaNnzDzrhbyR71d4cMDjDQY4AHMzvcSmkudYmLLkDeiz5l7yNbyJy/NZ0gJd1tyBZyt5nrMcZIk0C9JxbdbwJ9SvhTzDPVJaayVfxKV2jJfGxRh/wvsh+8q4RDybG8+8nKgS3mvjRZ2bR1PyNTzfxNjE2MT4b2Lc9Y8Hz1TyHGd52XNbEdH6Qt58W3kCiEjFkQVt4JkAAAAASUVORK5CYII=)
    no-repeat;
}
.index-goods-title{
  width: 100%;
  display: inline-block;
}
.index-goods-total{
  float: right;
  margin-left: 10px;
  font-size: 14px;
}
.index-goods-total span{
  padding-left: 2px;
  padding-right: 2px;
  color: #0085ec;
  font-weight: bold;
  font-size: 16px;
}
.index_goods_list {
  /* background: #ffffff; */
  border: 0px solid #000;
  overflow: auto;
  zoom: 1;
  /* margin: 10px 0; */
  padding-bottom: 20px;
}
.index_goods_list ul {
  list-style: none;
  align-content: center;
  text-align: center;
}
.index_goods_list ul li {
  background: #ffffff;
  width: 200px;
  height: 290px;
  margin: 15px;
  float: left;
  padding: 18px 10px 0;
  background-color: #fff;
  color: #666;
  border-radius: 5px;
}
.index_goods_list_none {
  display: none;
}
.index_goods_img {
  width: 180px;
  height: 180px;
  margin-bottom: 5px;
}
.index_goods_img img {
  width: 160px;
  height: 160px;
}
.index_goods_list span {
  /* font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  word-break: break-all;
  height: 48px; */
  font-size: 14px;
  line-height: 24px;
  height: 42px;
  text-align: left;
  color: #666;
  -webkit-transition: color 0.2s ease;
  transition: color 0.2s ease;
  word-break: break-all;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.more2_info_self {
  background-color: #e1251b;
  border-radius: 2px;
  color: #fff;
  padding: 0 5px;
  margin-right: 4px;
  line-height: 16px;
  height: 16px;
  font-size: 12px;
  display: inline-block;
  font-family: Helvetica Neue, Hiragino Sans GB, SimSun, serif;
}
.index-goods-button {
  padding: 50px;
  font-size: 26px;
  font-weight: 700;
  text-align: center;
  color: #333;
}
.index-goods-price {
  margin: 8px 0px;
  color: #999;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/footer/Partner.vue